<!-- <IFA-header></IFA-header> -->

<main id="primary" class="site-main customMain">
  <section
    id="mutual_funds_block_5f927b3385b13"
    class="types-mutual-fund-section mt-40">
    <div class="container px-4 pt-5 mt-120">
      <div class="content-panelMobile">
        <div class="row d-flex">
          <div class="col-12 MobileHide">
            <div class="sb-tag sb-offerings mb-12">mutual funds</div>
            <h2 class="wealth-section-title mb-6">
              Various types of Mutual Funds
            </h2>
            <p class="wealth-section-description">
              Let's learn types of Mutual Funds available & why so.
            </p>
          </div>
        </div>
        <div class="pt-8 tab-wrapper mutual-fund-type md:pt-6" id="tyesofMF">
          <div class="overflow-x-auto width-xll">
            <div class="inline-block min-w-full align-middle">
              <ul
                id="mutualFund"
                class="CustomNavigation flex flex-no-wrap mb-1 text-center border-b-2 border-gray-200 tabs">
                <li
                  class="w-1/4 p-4 text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                  <a data-toggle="tab" href="#mutual-1">Equity</a>
                </li>
                <li
                  class="w-1/4 p-4 text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                  <a data-toggle="tab" href="#mutual-2">Debt</a>
                </li>
                <li
                  class="w-1/4 p-4 text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                  <a data-toggle="tab" href="#mutual-3">Liquid</a>
                </li>
                <li
                  class="w-1/4 p-4 text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                  <a data-toggle="tab" href="#mutual-4">Balanced</a>
                </li>
                <li
                  class="w-1/4 p-4 text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                  <a data-toggle="tab" href="#mutual-5">ELSS</a>
                </li>
                <li
                  class="w-1/4 p-4 text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                  <a data-toggle="tab" href="#mutual-6">ETF</a>
                </li>
                <li
                  class="w-1/4 p-4 text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                  <a data-toggle="tab" href="#mutual-7">Gold ETFs</a>
                </li>
                <li
                  class="w-1/4 p-4 text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                  <a data-toggle="tab" href="#mutual-8">FoF</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="tab-content">
            <div
              id="mutual-1"
              class="wp-block-group mutual-fund-content tab-pane fade in active show">
              <div class="wp-block-group__inner-container">
                <div
                  class="Optimum-official-offerings"
                  id="Optimum-wealth-home">
                  <div
                    class="home-wealth-faq typeofmfsection wealth-faq-wrapper"
                    id="Myth">
                    <div class="container">
                      <div class="row">
                        <div class="col-12 nopadding">
                          <div class="accordion_container">
                            <div
                              class="col-sm-12 col-md-12 col-xs-12 nopadding">
                              <div class="row">
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-left-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      What is an 'Equity Fund'
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          An equity fund is a mutual fund scheme
                                          that invests predominantly in equity
                                          stocks.
                                        </p>
                                        <p>
                                          In the Indian context, as per current
                                          SEBI Mutual Fund Regulations, an
                                          equity mutual fund scheme must invest
                                          at least 65% of the scheme’s assets in
                                          equities and equity related
                                          instruments.
                                        </p>
                                        <!--<p>Under the tax regime in India, equity funds enjoy certain tax advantages (such as, there is no incidence of  long term capital gains tax on equity shares or equity funds which are held for at least 12 months from the date of acquisition). As per current Income Tax  rules, an <strong>"Equity Oriented Fund"</strong> means a Mutual Fund Scheme where the investible funds are invested in equity shares in domestic companies to the extent of more than 65% of the total proceeds of such fund.</p>-->
                                        <p>
                                          An Equity Fund can be actively managed
                                          or passively managed. Index funds and
                                          ETFs are passively managed.
                                        </p>
                                        <p>
                                          Equity mutual funds are principally
                                          categorized according to company size,
                                          the investment style of the holdings
                                          in the portfolio and geography.
                                        </p>
                                        <p>
                                          The size of an equity fund is
                                          determined by a market capitalization,
                                          while the investment style, reflected
                                          in the fund's stock holdings, is also
                                          used to categorize equity mutual
                                          funds.
                                        </p>
                                        <p>
                                          Equity funds are also categorized by
                                          whether they are domestic (investing
                                          in stocks of only Indian companies) or
                                          international (investing in stocks of
                                          overseas companies). These can be
                                          broad market, regional or
                                          single-country funds.
                                        </p>
                                        <p>
                                          Some specialty equity funds target
                                          business sectors, such as health care,
                                          commodities and real estate and are
                                          known as Sectoral Funds.
                                        </p>
                                        <h2
                                          class="sub-head-new sub-heading main-block animated fadeInDown">
                                          Ideal Investment Vehicle
                                        </h2>
                                        <p>
                                          In many ways, equity funds are ideal
                                          investment vehicles for investors that
                                          are not as well-versed in financial
                                          investing or do not possess a large
                                          amount of capital with which to
                                          invest. Equity funds are practical
                                          investments for most people.
                                        </p>
                                        <p>
                                          The attributes that make equity funds
                                          most suitable for small individual
                                          investors are the reduction of risk
                                          resulting from a fund's portfolio
                                          diversification and the relatively
                                          small amount of capital required to
                                          acquire shares of an equity fund. A
                                          large amount of investment capital
                                          would be required for an individual
                                          investor to achieve a similar degree
                                          of risk reduction through
                                          diversification of a portfolio of
                                          direct stock holdings. Pooling small
                                          investors' capital allows an equity
                                          fund to diversify effectively without
                                          burdening each investor with large
                                          capital requirements.
                                        </p>
                                        <p>
                                          The price of the equity fund is based
                                          on the fund's net asset value (NAV)
                                          less its liabilities. A more
                                          diversified fund means that there is
                                          less negative effect of an individual
                                          stock's adverse price movement on the
                                          overall portfolio and on the share
                                          price of the equity fund.
                                        </p>
                                        <p>
                                          Equity funds are managed by
                                          experienced professional portfolio
                                          managers, and their past performance
                                          is a matter of public record.
                                          Transparency and reporting
                                          requirements for equity funds are
                                          heavily regulated by the federal
                                          government.
                                        </p>
                                        <h2
                                          class="sub-head-new sub-heading main-block animated fadeInDown">
                                          A Fund for Everyone
                                        </h2>

                                        <p>
                                          Equity funds are very popular amongst
                                          the retail investors among various
                                          categories of mutual fund products.
                                          Whether it’s a particular market
                                          sector (technology, financial,
                                          pharmaceutical), a specific stock
                                          exchange (such as the BSE or NSE),
                                          foreign or domestic markets, income or
                                          growth stocks, high or low risk, or a
                                          specific interest group (political,
                                          religious, brand), there are equity
                                          funds of every type and characteristic
                                          available to match every risk profile
                                          and investment objective that
                                          investors may have.
                                        </p>
                                        <h2
                                          class="sub-head-new sub-heading main-block animated fadeInDown">
                                          What are different categories of
                                          Equity Funds
                                        </h2>
                                        <p>
                                          There are different types of equity
                                          mutual fund schemes and each offers a
                                          different type of underlying portfolio
                                          that have different levels of market
                                          risk.
                                        </p>
                                        <p>
                                          <strong>
                                            Large Cap Equity Funds
                                          </strong>
                                          invest a large portion of their corpus
                                          in companies with large market
                                          capitalization are called large-cap
                                          funds. This type of fund is known to
                                          offer stability and sustainable
                                          returns, over a period of time.
                                        </p>
                                        <p>
                                          Large Cap companies are generally very
                                          stable and dominate their industry.
                                          Large-cap stocks tend to hold up
                                          better in recessions, but they also
                                          tend to underperform small-cap stocks
                                          when the economy emerges from a
                                          recession. Large-cap tend to be less
                                          volatile than mid-cap and small-cap
                                          stocks and are therefore considered
                                          less risky.
                                        </p>
                                        <p>
                                          <strong>Mid-Cap Equity Funds</strong>
                                          invest in stocks of mid-size
                                          companies, which are still considered
                                          developing companies. Mid-cap stocks
                                          tend to be riskier than large-cap
                                          stocks but less risky than small-cap
                                          stocks. Mid-cap stocks, however, tend
                                          to offer more growth potential than
                                          large-cap stocks.
                                        </p>
                                        <p>
                                          <strong>Small Cap</strong>
                                          Funds invest in stocks of
                                          smaller-sized companies.
                                          <strong>Small cap</strong>
                                          is a term used to classify companies
                                          with a relatively
                                          <strong>small</strong>
                                          market capitalization. However, the
                                          definition of
                                          <strong>small cap</strong>
                                          can vary among market intermediaries,
                                          but it is generally regarded as a
                                          company with a market capitalization
                                          of less than ₹ 100 crores. Many small
                                          caps are young companies with
                                          significant growth potential. However,
                                          the risk of failure is greater with
                                          small-cap stocks than with large-cap
                                          and mid-cap stocks. As a result,
                                          small-cap stocks tend to be the more
                                          volatile (and therefore riskier) than
                                          large-cap and mid-cap stocks.
                                          Historically, small-cap stocks have
                                          typically underperformed large-cap
                                          stocks during recessions but have
                                          outperformed large-cap stocks as the
                                          economy has emerged from recessions.
                                        </p>
                                        <p>
                                          The smallest stocks of the small caps
                                          are called
                                          <strong>micro-cap</strong>
                                          stocks. While the opportunity for
                                          these companies to experience extreme
                                          growth is great, the risk to lose a
                                          large amount of money is also possible
                                        </p>
                                        <p>
                                          <strong>
                                            Multi Cap Equity Funds
                                          </strong>
                                          or
                                          <strong>
                                            Diversified Equity Funds
                                          </strong>
                                          invests in stocks of companies across
                                          the stock market regardless of size
                                          and sector. These funds provide the
                                          benefit of diversification by
                                          investing in companies spread across
                                          sectors and market capitalisation.
                                          They are generally meant for investors
                                          who seek exposure across the market
                                          and do not want to be restricted to
                                          any particular sector. They invest in
                                          companies across different market caps
                                          and hence reduce the amount of risk in
                                          the fund. Diversification helps
                                          prevent events that could affect a
                                          single sector for affecting the fund,
                                          and hence reduce risk.
                                        </p>
                                        <p class="pad-bord">
                                          <strong>Market capitalization</strong>
                                          (commonly known as market cap) is
                                          calculated by multiplying a company’s
                                          outstanding shares by its stock price
                                          per share. A company’s stock price by
                                          itself does not tell much about the
                                          total value or size of a company; a
                                          company whose stock price is say ₹500
                                          is not necessarily worth more than a
                                          company whose stock price is say,
                                          ₹250. For example, a company with a
                                          stock price of ₹500 and 10 million
                                          shares outstanding (a market cap of ₹5
                                          billion) is actually smaller in size
                                          than a company with a stock price of
                                          ₹250 and 50 million shares outstanding
                                          (a market cap of ₹12.5 billion).
                                        </p>
                                        <p>
                                          <strong>
                                            Thematic Equity Funds:
                                          </strong>
                                          &nbsp;These funds invest in securities
                                          of specific sectors such as
                                          Information Technology, Banking,
                                          Service and pharma sector etc., which
                                          is specified in their scheme
                                          information documents. So, the
                                          performance of these schemes depends
                                          on the performance of the respective
                                          sector. These funds may give higher
                                          returns, but they also come with
                                          increased risks
                                        </p>
                                        <h2
                                          class="sub-head-new sub-heading main-block animated fadeInDown">
                                          Equity Linked Savings Scheme
                                          (ELSS):&nbsp;
                                        </h2>
                                        <p>
                                          Equity-Linked Savings Scheme (ELSS) is
                                          an equity mutual fund investment that
                                          invests at least 80 per cent of its
                                          assets in equity and equity-related
                                          instruments. ELSS can be open-ended or
                                          close ended. Investments in an ELSS
                                          qualify for tax deductions under
                                          Section 80C of the Income Tax Act
                                          within the overall limit of ₹1.5 lakh.
                                          The amount you invest in ELSS is
                                          deducted from your taxable income,
                                          which helps you lower the amount of
                                          income tax you are liable to pay.
                                          Investments in ELSS are subject to a
                                          three-year lock-in period.
                                        </p>
                                        <p class="pad-bord">
                                          Investing in equity mutual funds comes
                                          at slightly higher risk as compared to
                                          debt mutual funds, but they also give
                                          your money a chance to earn higher
                                          returns. Now that you know more about
                                          different types of equity mutual
                                          funds, what are you waiting for?
                                          Contact your investment advisor today.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Ideal Investment Vehicle
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div
                                        class="wealth-faq-collapse-content"
                                        itemprop="text">
                                        <p>
                                          In many ways, equity funds are ideal
                                          investment vehicles for investors that
                                          are not as well-versed in financial
                                          investing or do not possess a large
                                          amount of capital with which to
                                          invest. Equity funds are practical
                                          investments for most people.
                                        </p>
                                        <p>
                                          The attributes that make equity funds
                                          most suitable for small individual
                                          investors are the reduction of risk
                                          resulting from a fund's portfolio
                                          diversification and the relatively
                                          small amount of capital required to
                                          acquire shares of an equity fund. A
                                          large amount of investment capital
                                          would be required for an individual
                                          investor to achieve a similar degree
                                          of risk reduction through
                                          diversification of a portfolio of
                                          direct stock holdings. Pooling small
                                          investors' capital allows an equity
                                          fund to diversify effectively without
                                          burdening each investor with large
                                          capital requirements.
                                        </p>
                                        <p>
                                          The price of the equity fund is based
                                          on the fund's net asset value (NAV)
                                          less its liabilities. A more
                                          diversified fund means that there is
                                          less negative effect of an individual
                                          stock's adverse price movement on the
                                          overall portfolio and on the share
                                          price of the equity fund.
                                        </p>
                                        <p>
                                          Equity funds are very popular amongst
                                          the retail investors among various
                                          categories of mutual fund products.
                                          Whether it’s a particular market
                                          sector (technology, financial,
                                          pharmaceutical), a specific stock
                                          exchange (such as the BSE or NSE),
                                          foreign or domestic markets, income or
                                          growth stocks, high or low risk, or a
                                          specific interest group (political,
                                          religious, brand), there are equity
                                          funds of every type and characteristic
                                          available to match every risk profile
                                          and investment objective that
                                          investors may have.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-right-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      What are different categories of Equity
                                      Funds
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          There are different types of equity
                                          mutual fund schemes and each offers a
                                          different type of underlying portfolio
                                          that have different levels of market
                                          risk.
                                        </p>
                                        <p>
                                          <strong>
                                            Large Cap Equity Funds
                                          </strong>
                                          invest a large portion of their corpus
                                          in companies with large market
                                          capitalization are called large-cap
                                          funds. This type of fund is known to
                                          offer stability and sustainable
                                          returns, over a period of time.
                                        </p>
                                        <p>
                                          Large Cap companies are generally very
                                          stable and dominate their industry.
                                          Large-cap stocks tend to hold up
                                          better in recessions, but they also
                                          tend to underperform small-cap stocks
                                          when the economy emerges from a
                                          recession. Large-cap tend to be less
                                          volatile than mid-cap and small-cap
                                          stocks and are therefore considered
                                          less risky.
                                        </p>
                                        <p>
                                          <strong>Mid-Cap Equity Funds</strong>
                                          invest in stocks of mid-size
                                          companies, which are still considered
                                          developing companies. Mid-cap stocks
                                          tend to be riskier than large-cap
                                          stocks but less risky than small-cap
                                          stocks. Mid-cap stocks, however, tend
                                          to offer more growth potential than
                                          large-cap stocks.
                                        </p>
                                        <p>
                                          <strong>Small Cap</strong>
                                          Funds invest in stocks of
                                          smaller-sized companies.
                                          <strong>Small cap</strong>
                                          is a term used to classify companies
                                          with a relatively
                                          <strong>small</strong>
                                          market capitalization. However, the
                                          definition of
                                          <strong>small cap</strong>
                                          can vary among market intermediaries,
                                          but it is generally regarded as a
                                          company with a market capitalization
                                          of less than ₹ 100 crores. Many small
                                          caps are young companies with
                                          significant growth potential. However,
                                          the risk of failure is greater with
                                          small-cap stocks than with large-cap
                                          and mid-cap stocks. As a result,
                                          small-cap stocks tend to be the more
                                          volatile (and therefore riskier) than
                                          large-cap and mid-cap stocks.
                                          Historically, small-cap stocks have
                                          typically underperformed large-cap
                                          stocks during recessions but have
                                          outperformed large-cap stocks as the
                                          economy has emerged from recessions.
                                        </p>
                                        <p>
                                          The smallest stocks of the small caps
                                          are called
                                          <strong>micro-cap</strong>
                                          stocks. While the opportunity for
                                          these companies to experience extreme
                                          growth is great, the risk to lose a
                                          large amount of money is also possible
                                        </p>
                                        <p>
                                          <strong>
                                            Multi Cap Equity Funds
                                          </strong>
                                          or
                                          <strong>
                                            Diversified Equity Funds
                                          </strong>
                                          invests in stocks of companies across
                                          the stock market regardless of size
                                          and sector. These funds provide the
                                          benefit of diversification by
                                          investing in companies spread across
                                          sectors and market capitalisation.
                                          They are generally meant for investors
                                          who seek exposure across the market
                                          and do not want to be restricted to
                                          any particular sector. They invest in
                                          companies across different market caps
                                          and hence reduce the amount of risk in
                                          the fund. Diversification helps
                                          prevent events that could affect a
                                          single sector for affecting the fund,
                                          and hence reduce risk.
                                        </p>
                                        <p class="pad-bord">
                                          <strong>Market capitalization</strong>
                                          (commonly known as market cap) is
                                          calculated by multiplying a company’s
                                          outstanding shares by its stock price
                                          per share. A company’s stock price by
                                          itself does not tell much about the
                                          total value or size of a company; a
                                          company whose stock price is say ₹500
                                          is not necessarily worth more than a
                                          company whose stock price is say,
                                          ₹250. For example, a company with a
                                          stock price of ₹500 and 10 million
                                          shares outstanding (a market cap of ₹5
                                          billion) is actually smaller in size
                                          than a company with a stock price of
                                          ₹250 and 50 million shares outstanding
                                          (a market cap of ₹12.5 billion).
                                        </p>
                                        <p>
                                          <strong>
                                            Thematic Equity Funds:
                                          </strong>
                                          &nbsp;These funds invest in securities
                                          of specific sectors such as
                                          Information Technology, Banking,
                                          Service and pharma sector etc., which
                                          is specified in their scheme
                                          information documents. So, the
                                          performance of these schemes depends
                                          on the performance of the respective
                                          sector. These funds may give higher
                                          returns, but they also come with
                                          increased risks
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Equity Linked Savings Scheme (ELSS):
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div
                                        class="wealth-faq-collapse-content"
                                        itemprop="text">
                                        <p>
                                          Equity-Linked Savings Scheme (ELSS) is
                                          an equity mutual fund investment that
                                          invests at least 80 per cent of its
                                          assets in equity and equity-related
                                          instruments. ELSS can be open-ended or
                                          close ended. Investments in an ELSS
                                          qualify for tax deductions under
                                          Section 80C of the Income Tax Act
                                          within the overall limit of ₹1.5 lakh.
                                          The amount you invest in ELSS is
                                          deducted from your taxable income,
                                          which helps you lower the amount of
                                          income tax you are liable to pay.
                                          Investments in ELSS are subject to a
                                          three-year lock-in period.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="mutual-2"
              class="wp-block-group mutual-fund-content tab-pane fade">
              <div class="wp-block-group__inner-container">
                <div
                  class="Optimum-official-offerings"
                  id="Optimum-wealth-home">
                  <div
                    class="home-wealth-faq typeofmfsection wealth-faq-wrapper"
                    id="Myth1">
                    <div class="container">
                      <div class="row">
                        <div class="col-12 nopadding">
                          <div class="accordion_container">
                            <div
                              class="col-sm-12 col-md-12 col-xs-12 nopadding">
                              <div class="row">
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-left-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      what is debt fund?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          A debt fund is a mutual fund scheme
                                          that invests in fixed income
                                          instruments, such as Corporate and
                                          Government Bonds, corporate debt
                                          securities, and money market
                                          instruments etc. that offer capital
                                          appreciation. Debt funds are also
                                          referred to as Income Funds or Bond
                                          Funds.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      who should invest in a debt fund?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Debt funds are ideal for investors who
                                          want regular income, but are
                                          risk-averse. Debt funds are less
                                          volatile and, hence, are less risky
                                          than equity funds. If you have been
                                          saving in traditional fixed income
                                          products like Term Deposits, and
                                          looking for steady returns with low
                                          volatility, debt mutual funds could be
                                          a better option, as they help you
                                          achieve your financial goals in a more
                                          tax efficient manner and therefore
                                          earn better returns.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      how debt funds are different from other
                                      mutual fund schemes?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Debt funds invest in either listed or
                                          unlisted debt instruments, such as
                                          Corporate and Government Bonds at a
                                          certain price and later sell them at a
                                          margin. The difference between the
                                          cost and sale price accounts for the
                                          appreciation or depreciation in the
                                          fund’s net asset value (NAV). Debt
                                          funds also receive periodic interest
                                          from the underlying debt instruments
                                          in which they invest. In terms of
                                          return, debt funds that earn regular
                                          interest from the fixed income
                                          instruments during the fund’s tenure
                                          are similar to bank fixed deposits
                                          that earn interest. This interest
                                          income gets added to a debt fund on a
                                          daily basis. If the interest payment
                                          is received, say, once every year, it
                                          is divided by 365 and the debt fund’s
                                          NAV goes up daily by this small
                                          amount. Thus, a debt scheme’s NAV also
                                          depends on the interest rates of its
                                          underlying assets and also on any
                                          upgrade or downgrade in the credit
                                          rating of its holdings.
                                        </p>

                                        <p>
                                          Market prices of debt securities
                                          change with movements in interest
                                          rates. Let’s assume, your debt fund
                                          owns a security that yields 10 %
                                          interest. If the interest rate in the
                                          economy falls, new instruments issued
                                          in the market would offer this lower
                                          rate. To match this lower rate, there
                                          would be an increase in the prices
                                          your fund’s underlying instruments as
                                          they have a higher coupon (interest)
                                          rate. As a result of the increase in
                                          the debt instrument’s value, your
                                          fund’s NAV, too, would increase.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      why invest in debt mutual funds?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          A few major advantages of investing in
                                          debt funds are low cost structure,
                                          stable returns, high liquidity and
                                          reasonablesafety. Debt funds also
                                          score on post-tax return. Dividends
                                          from debt funds are exempt from tax in
                                          the hands of investors.The mutual
                                          fund, however, has to pay a Dividend
                                          Distribution Tax, which is currently
                                          28.325 per cent in case of individuals
                                          or Hindu undivided families. While
                                          long-term capital gains from debt
                                          funds are taxed at 10 per cent without
                                          indexation and 20 per cent with
                                          indexation, short-term capital gains
                                          taxes are levied according to the
                                          income-tax bracket one belongs to.
                                        </p>

                                        <p>
                                          Thus, debt funds can be a good
                                          alternative to investors for achieving
                                          their financial goals if they do not
                                          intend to bear risk involved in equity
                                          investments.
                                        </p>

                                        <p>
                                          <strong>
                                            Growth Option vs. Dividend Option
                                          </strong>
                                          <br />
                                          As mentioned above, dividend from
                                          mutual funds is tax free in the hands
                                          of the investors, but the same is
                                          subject to Dividend Distribution Tax
                                          (currently 28.325 %), which indirectly
                                          decreases the net returns. Hence,
                                          dividend payment or dividend
                                          reinvestment option gives better
                                          post-tax returns, to those who are in
                                          the highest tax bracket. However, for
                                          those in lower tax slabs, growth
                                          option could be more tax-efficient. In
                                          short, one should choose the
                                          appropriate option depending on the
                                          tax bracket.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-right-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      who should invest in debt mutual funds?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          There’s no fixed rule as to who should
                                          invest in debt funds. It depends on
                                          the requirement of investors.
                                          Different types of investors invest in
                                          different types of debt funds. For
                                          instance, if someone wants to park his
                                          emergency funds, he can go for liquid
                                          funds.
                                        </p>

                                        <p>
                                          As a thumb rule, 3-6 month’s household
                                          expenses can be one’s emergency fund
                                          depending on the age. Roughly the
                                          amount that gives you the confidence
                                          to combat emergencies in your
                                          household should be enough. Anything
                                          more can actually affect your
                                          investment portfolio. Those in their
                                          20s and 30s might need more, so garner
                                          funds for about six months’ expenses,
                                          whereas those nearing retirement might
                                          not need much as they would have built
                                          up their reserves. The amount you save
                                          for an emergency depends ultimately on
                                          what makes you comfortable.
                                        </p>

                                        <p>
                                          If you are the risk-averse type, then
                                          you might prefer a large fund of, say,
                                          a year’s salary. If, however, you are
                                          the living on-the-edge type, then six
                                          months’ salary might suffice.
                                        </p>

                                        <p>
                                          For those planning to buy a home after
                                          2-3 years, investing in a combination
                                          of both long- and short-term debt
                                          funds might be a good idea. Also, a
                                          debt fund can be used in the overall
                                          portfolio for diversification across
                                          asset classes. Debt Funds can also be
                                          used for portfolio de-risking when you
                                          are nearing your financial goals.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      how to pick the right debt fund?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Remember, it is the asset allocation
                                          (government securities, corporate debt
                                          and marketable securities) that
                                          largely determines how a debt fund’s
                                          NAV will move. A close look at a
                                          fund’s portfolio composition will give
                                          you an idea of the expected returns,
                                          risks and liquidity. So, when picking
                                          a fund, watch out for a few things.
                                        </p>

                                        <p>
                                          One, check the average maturity of the
                                          fund’s portfolio as this has a bearing
                                          on your returns. The lower the average
                                          maturity period, the lower the fund’s
                                          volatility and your returns. On the
                                          other hand, a fund with a long
                                          maturity period is likely to be more
                                          volatile, but the returns are likely
                                          to be better.
                                        </p>

                                        <p>
                                          Two, make sure the fund’s portfolio is
                                          reasonably liquid. A large percentage
                                          of corporate debt in the portfolio
                                          does not bode well in the short term,
                                          as it is relatively less liquid. If
                                          the fund faces redemption pressure, it
                                          would be forced to sell these
                                          securities at a discount, lowering the
                                          NAV. Also, be wary of funds that hold
                                          a lot of unrated and unlisted debt.
                                        </p>

                                        <p>
                                          Three, avoid schemes with small
                                          corpuses. That’s because funds don’t
                                          disclose if there are any investor who
                                          owns a substantial chunk of
                                          outstanding units. If there are such
                                          investors and they decide to redeem
                                          their holdings, the fund could be
                                          forced to sell holdings below the
                                          market rates.
                                        </p>

                                        <p>
                                          Four, the best tool to capture the
                                          interest rate sensitivity of a debt
                                          fund is modified duration. It tells
                                          you how much the price of a bond would
                                          move if interest rates move up or down
                                          by 1 per cent. The higher the modified
                                          duration, the greater will be the
                                          impact of an interest rate change.
                                          Mutual funds give you access to all
                                          the information in their offer
                                          documents and other periodic
                                          disclosures for you to make an
                                          informed decision. It is then up to
                                          you to take the investment decision
                                          and sign the form, or channel the
                                          money to suit your financial needs.
                                        </p>

                                        <p>
                                          Also, you should understand how
                                          interest rate movements, credit
                                          ratings and liquidity affect a debt
                                          fund’s performance. Theoretically, if
                                          interest rates rise, the NAV of a debt
                                          fund should fall. That’s because Bond
                                          prices move in the opposite direction
                                          as interest rates. A fall in bond
                                          prices leads to a decline in a fund’s
                                          NAV. The opposite would happen if
                                          interest rates fell. Of course, in an
                                          imperfect and illiquid market like
                                          India, this might not happen to the
                                          entire extent. Moreover, if some bonds
                                          held by your debt fund are upgraded,
                                          their prices would rise, leading to a
                                          drop in yields. That would, of course,
                                          increase your fund’s NAV. So, one
                                          should be prepared for fluctuations in
                                          one’s fund’s NAV. Even Gilt Funds
                                          (which invest only in government
                                          securities) that are advertised as the
                                          safest available investments, can
                                          witness sharp fluctuations in their
                                          NAVs. That’s because prices of
                                          government securities are a function
                                          of various economic factors, including
                                          interest rates, macroeconomic data and
                                          liquidity in the banking system. When
                                          these change, so do the Gilt Fund’s
                                          NAV.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      What is average maturity and how is it
                                      useful?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Debt funds invest in a number of debt
                                          instruments, all of them having a
                                          varying maturity. That’s where the
                                          average maturity comes handy. As the
                                          name suggests, it basically indicates
                                          the average maturity of all the
                                          securities in a portfolio, giving you
                                          the freedom to compare.
                                        </p>

                                        <p>
                                          Average maturity thus gives you a
                                          quick glimpse into the sensitivity of
                                          the bond to interest rates. Funds with
                                          higher average maturities tend to be
                                          more volatile in the short term since
                                          their objective is to deliver higher
                                          returns over the long term. Simply
                                          put, a fund with an average maturity
                                          of 5 years is definitely more volatile
                                          in the short term than a fund with an
                                          average maturity of say 9 months.
                                          That’s because in the shorter term
                                          there is reasonable surety on the
                                          receipt of the coupon income.
                                        </p>

                                        <p>
                                          So matching your investment horizon
                                          with the average maturity is always a
                                          good idea. But remember, an average
                                          maturity of say 4 years doesn’t
                                          necessarily mean that you have to hold
                                          it for 4 years. But it definitely
                                          indicates is that you can expect to
                                          get optimal returns, given the
                                          interest rate environment, over 4
                                          years.
                                        </p>
                                        <p>
                                          Exit load isan effective mechanism
                                          that prompts investors to stay
                                          invested through the desired holding
                                          period. This ensures that investors,
                                          who move in and out of the fund and
                                          take away accrued gains during
                                          momentary positive market movements,
                                          do not short-change diligent investors
                                          who stay invested for the entire
                                          course.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Why is it essential to match the
                                      investment horizon with that the scheme?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Funds having a lower average maturity
                                          are ideal for short-term holdings as
                                          they are well protected from the
                                          fluctuating interest rate movements.
                                          However, holding them for more than
                                          their average maturity may not get you
                                          the optimal results.There can be
                                          various types of debt funds based on
                                          the average maturity of the
                                          instruments invested in. Although debt
                                          funds are less risky than equity
                                          funds, they are still subject to
                                          market volatility.The level of
                                          volatility therefore depends on the
                                          average maturity of the specific
                                          portfolio.
                                        </p>

                                        <p>
                                          The higher the average maturity, the
                                          greater the uncertainty in the short
                                          term, which is what results in greater
                                          volatility. Conversely, the lower the
                                          average maturity, the greater the
                                          certainty, which in turn lowers
                                          volatility.
                                        </p>

                                        <p>
                                          Liquid funds are the least volatile as
                                          their maturity is in days and at the
                                          other extreme there are income funds,
                                          where the average maturity is in
                                          multiple of years.
                                        </p>

                                        <p>
                                          So in order to really get the most out
                                          of debt funds, it is essential that
                                          you match your investment horizon with
                                          the average maturity of the scheme.
                                        </p>
                                        <p>
                                          <strong>
                                            USING DEBT FUNDS FOR STP AND SWP
                                          </strong>
                                          <br />
                                          Debt funds also allow you to take
                                          advantage of investing in equity
                                          market along with growth on your
                                          principal amount through Systematic
                                          Transfer Plan (STP). With an STP, you
                                          can transfer amounts in parts/tranches
                                          from one mutual fund scheme to
                                          another, within the same fund house at
                                          regular intervals. Such a transfer
                                          averages the cost of
                                          purchase,mitigating some
                                          market-related risks. Typically, an
                                          investor first parks his funds in a
                                          liquid or a floating-rate debt fund
                                          and then transfers them via STP to the
                                          scheme (usually equity or balanced) of
                                          his choice at regular intervals.
                                        </p>

                                        <p>
                                          Systematic withdrawal plan (SWP) is a
                                          payment option in a mutual fund that
                                          lets you redeem units worth a
                                          pre-specified amount at a specific
                                          intervals (monthly, quarterly,
                                          half-yearly or annually). This is
                                          suitable for the investors who desire
                                          periodic income.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-left-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      how debt funds work?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Debt funds invest in either listed or
                                          unlisted debt instruments, such as
                                          Corporate and Government Bonds at a
                                          certain price and later sell them at a
                                          margin. The difference between the
                                          cost and sale price accounts for the
                                          appreciation or depreciation in the
                                          fund’s net asset value (NAV). Debt
                                          funds also receive periodic interest
                                          from the underlying debt instruments
                                          in which they invest. In terms of
                                          return, debt funds that earn regular
                                          interest from the fixed income
                                          instruments during the fund’s tenure
                                          are similar to bank fixed deposits
                                          that earn interest. This interest
                                          income gets added to a debt fund on a
                                          daily basis. If the interest payment
                                          is received, say, once every year, it
                                          is divided by 365 and the debt fund’s
                                          NAV goes up daily by this small
                                          amount. Thus, a debt scheme’s NAV also
                                          depends on the interest rates of its
                                          underlying assets and also on any
                                          upgrade or downgrade in the credit
                                          rating of its holdings.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-left-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Using debt funds for specific goals
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          When moving away from high-risk
                                          options, you could choose to move into
                                          liquid and short-term debt funds or
                                          slightly riskier funds in the debt
                                          space, such as bond and gilt funds,
                                          depending on the interest rate
                                          scenario prevailing at that time. For
                                          instance, if the interest rates are
                                          falling, short- to long-term bond and
                                          gilt funds would bode well. But if
                                          interest rates remain flat or move
                                          upwards, stick to liquid funds; they
                                          are safer than the rest of the debt
                                          schemes, if not the safest of all
                                          financial instruments, and they would
                                          still earn you more than your savings
                                          bank account.
                                        </p>

                                        <p>
                                          The ideal way to build an adequate
                                          corpus for your child’s future is to
                                          go step by step – through Systematic
                                          Investment Plan or SIP. The sooner you
                                          start, the better. Of course, you also
                                          need to stop along the way
                                          occasionally to make sure things are
                                          going as planned. The closer you get
                                          to your investment goal, the more
                                          careful you need to be that you are
                                          not taking a wrong turn.
                                        </p>

                                        <p>
                                          <strong>
                                            Role of debt fund in retirement
                                            portfolio.
                                          </strong>
                                          <br />
                                          As you age, lighten your equity funds
                                          holdings marginally; the aggressive
                                          investor should cut equity in his
                                          portfolio from 80 per cent to 70 per
                                          cent, and the conservative investor
                                          from 60 per cent to 40 per cent. With
                                          about 15 years away from retirement,
                                          you should start playing steady and
                                          balance your exposure to debt and
                                          equity. For instance, the conservative
                                          investor may choose a 10-20 per cent
                                          higher debt allocation. On the debt
                                          side, you may look at floating-rate
                                          funds and fixed maturity plans.
                                          Balanced funds are another option for
                                          the semi-aggressive investor to strike
                                          a debt-equity mix.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="mutual-3"
              class="wp-block-group mutual-fund-content tab-pane fade">
              <div class="wp-block-group__inner-container">
                <div
                  class="Optimum-official-offerings"
                  id="Optimum-wealth-home">
                  <div
                    class="home-wealth-faq typeofmfsection wealth-faq-wrapper"
                    id="Myth1">
                    <div class="container">
                      <div class="row">
                        <div class="col-12 nopadding">
                          <div class="accordion_container">
                            <div
                              class="col-sm-12 col-md-12 col-xs-12 nopadding">
                              <div class="row">
                                <div
                                  class="col-md-12 col-xs-12 col-sm-12 mbnopadding">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Liquid Funds
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Liquid Funds, as the name suggests,
                                          invest predominantly in highly liquid
                                          money market instruments and debt
                                          securities of very short tenure and
                                          hence provide high liquidity. They
                                          invest in very short-term instruments
                                          such as Treasury Bills (T-bills),
                                          Commercial Paper (CP), Certificates Of
                                          Deposit (CD) and Collateralized
                                          Lending &amp; Borrowing Obligations
                                          (CBLO) that have residual maturities
                                          of up to 91 days to generate optimal
                                          returns while maintaining safety and
                                          high liquidity. Redemption requests in
                                          these Liquid funds are processed
                                          within one working (T+1) day.
                                        </p>

                                        <p>
                                          The aim of the fund manager of a
                                          Liquid Fund is to invest only into
                                          liquid investments with good credit
                                          rating with very low possibility of a
                                          default. The returns typically take
                                          the back seat as protection of capital
                                          remains of utmost importance. Control
                                          over expenses in the form of low
                                          expense ratio, good overall credit
                                          quality of the portfolio and a
                                          disciplined approach to investing are
                                          some of the key ingredients of a good
                                          liquid fund.
                                        </p>
                                        <p>
                                          Most retail customers prefer to keep
                                          their surplus cash in Savings Bank
                                          deposits as they consider the same to
                                          be safest and they could withdraw the
                                          money at any time. Liquid Funds and
                                          Money Market Mutual Funds provide a
                                          more attractive option. Surplus cash
                                          invested in money market mutual funds
                                          earns higher post-tax returns with a
                                          reasonable degree of safety of the
                                          principal invested and liquidity.
                                        </p>
                                        <p>
                                          Liquid funds are preferred by
                                          investors to park their money for
                                          short periods of time typically 1 day
                                          to 3 months. Wealth managers suggest
                                          liquid funds as an ideal parking
                                          ground when you have a sudden influx
                                          of cash, which could be a huge bonus,
                                          sale of real estate and so on and you
                                          are undecided about where to deploy
                                          that money. Investors looking out for
                                          opportunities in equities and
                                          long-term fixed income instruments can
                                          also park their money in the liquid
                                          funds in the meantime. Many equity
                                          investors use liquid funds to stagger
                                          their investments into equity mutual
                                          funds using the Systematic Transfer
                                          Plan (STP), as they believe this
                                          method could yield higher returns.
                                        </p>
                                        <p>
                                          Liquid Funds typically do not charge
                                          any exit loads. Investors are offered
                                          growth and dividend options. Within
                                          dividend option, investors can choose
                                          daily, weekly or monthly dividends
                                          depending on their investment horizon
                                          and investment amount. Redemption
                                          payment is typically made within one
                                          working day of placing the redemption
                                          request. With mutual funds going
                                          online, individual investors with
                                          small sums can look at Liquid funds as
                                          an effective short-term investment
                                          option over their savings bank
                                          account.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="mutual-4"
              class="wp-block-group mutual-fund-content tab-pane fade">
              <div class="wp-block-group__inner-container">
                <div
                  class="Optimum-official-offerings"
                  id="Optimum-wealth-home">
                  <div
                    class="home-wealth-faq typeofmfsection wealth-faq-wrapper"
                    id="Myth1">
                    <div class="container">
                      <div class="row">
                        <div class="col-12 nopadding">
                          <div class="accordion_container">
                            <div
                              class="col-sm-12 col-md-12 col-xs-12 nopadding">
                              <div class="row">
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-left-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      What is a 'Balanced Fund'
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          A balanced fund combines equity stock
                                          component, a bond component and
                                          sometimes a money market component in
                                          a single portfolio. Generally, these
                                          hybrid funds stick to a relatively
                                          fixed mix of stocks and bonds that
                                          reflects either a moderate, or higher
                                          equity, component, or conservative, or
                                          higher fixed-income, component
                                          orientation
                                        </p>
                                        <p>
                                          These funds invest in a mix of
                                          equities and debt, giving the investor
                                          the best of both worlds. Balanced
                                          funds gain from a healthy dose of
                                          equities but the debt portion
                                          fortifies them against any downturn.
                                        </p>
                                        <p>
                                          Balanced funds are suitable for a
                                          medium-term horizon and are ideal for
                                          investors who are looking for a
                                          mixture of safety, income and modest
                                          capital appreciation. The amounts this
                                          type of mutual fund invests into each
                                          asset class usually must remain within
                                          a set minimum and maximum.
                                        </p>
                                        <p>
                                          Although they are in the "asset
                                          allocation" family, balanced fund
                                          portfolios do not materially change
                                          their asset mix. This is unlike
                                          life-cycle, target-date and actively
                                          managed asset-allocation funds, which
                                          make changes in response to an
                                          investor's changing risk-return
                                          appetite and age or overall investment
                                          market conditions.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Equities and Inflation
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Investors who have dual investment
                                          objectives favour Balanced Funds.
                                          Typically, retirees or investors with
                                          low risk tolerance prefer these funds
                                          for growth that outpaces inflation and
                                          income that supplements current needs.
                                          While retirees generally scale back
                                          risk as age advances, many individuals
                                          recognize the need for equity exposure
                                          as life expectancies increase.
                                          Equities prevent erosion of purchasing
                                          power and help ensure long-term
                                          preservation of retirement corpus
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-right-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Income Needs
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          The bond component of a balanced fund
                                          serves two purposes: creating an
                                          income stream and moderating portfolio
                                          volatility. Investment-grade bonds
                                          such as AAA corporate bonds and Money
                                          market instruments interest income
                                          from periodic payments, while
                                          large-company stocks offer dividend
                                          payouts to enhance yield. Retired
                                          investors may take distributions in
                                          cash to bolster income from pensions
                                          and personal savings.
                                        </p>
                                        <p>
                                          Secondarily, bonds hold much less
                                          volatility than stocks. Bondholders
                                          have a claim against assets of a
                                          company while stocks represent
                                          ownership, bearing all inherent risk
                                          if bankruptcy occurs. Hence, debt
                                          security prices do not move in
                                          lockstep with equities, and their
                                          stability prevents wild swings in the
                                          share price of a balanced fund.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Taxation
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Equity-oriented Balanced funds have a
                                          larger portion of their corpus (at
                                          least 65%) invested in stocks and
                                          qualify for the same tax treatment as
                                          equity funds. This means any capital
                                          gains are tax-free, if the investment
                                          is held for more than one year.
                                          However, these funds are more volatile
                                          due to the higher allocation to
                                          stocks.
                                        </p>
                                        <p>
                                          Debt-oriented balanced funds are less
                                          volatile and suit those with a lower
                                          risk appetite. However, they offer
                                          lower returns and the gains are not
                                          eligible for tax exemption. If the
                                          investment is held for less than three
                                          years, the capital gains are treated
                                          as short term and taxed at the normal
                                          rates. But if the holding period
                                          exceeds three years, the gains are
                                          considered as long term and are taxed
                                          at 20% after indexation benefit, which
                                          can significantly reduce the tax.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="mutual-5"
              class="wp-block-group mutual-fund-content tab-pane fade">
              <div class="wp-block-group__inner-container">
                <div
                  class="Optimum-official-offerings"
                  id="Optimum-wealth-home">
                  <div
                    class="home-wealth-faq typeofmfsection wealth-faq-wrapper"
                    id="Myth1">
                    <div class="container">
                      <div class="row">
                        <div class="col-12 nopadding">
                          <div class="accordion_container">
                            <div
                              class="col-sm-12 col-md-12 col-xs-12 nopadding">
                              <div class="row">
                                <div
                                  class="col-md-12 col-xs-12 col-sm-12 mbnopadding">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      ELSS Fund – Tax Saving Mutual Fund
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          An ELSS is an Equity Linked Savings
                                          Scheme, that allows an individual or
                                          HUF a deduction from total income of
                                          up to Rs. 1.5 lacs under Sec 80C of
                                          Income Tax Act 1961. Thus if an
                                          investor was to invest Rs. 50,000 in
                                          an ELSS, then this amount would be
                                          deducted from the total taxable
                                          income, thus reducing her tax burden.
                                          These schemes have a lock-in period of
                                          three years from date of units
                                          allotment. After the lock-in period is
                                          over, the units are free to be
                                          redeemed or switched. ELSS offer both
                                          growth and dividend options. Investors
                                          can also invest through Systematic
                                          Investment Plans (SIP), and
                                          investments up to ₹ 1.5 lakhs, made in
                                          a financial year are eligible for tax
                                          deduction
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="mutual-6"
              class="wp-block-group mutual-fund-content tab-pane fade">
              <div class="wp-block-group__inner-container">
                <div
                  class="Optimum-official-offerings"
                  id="Optimum-wealth-home">
                  <div
                    class="home-wealth-faq typeofmfsection wealth-faq-wrapper"
                    id="Myth1">
                    <div class="container">
                      <div class="row">
                        <div class="col-12 nopadding">
                          <div class="accordion_container">
                            <div
                              class="col-sm-12 col-md-12 col-xs-12 nopadding">
                              <div class="row">
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-left-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      What is an ETF?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          An ETF, or exchange traded fund, is a
                                          marketable security that tracks an
                                          index, a commodity, bonds, or a basket
                                          of assets like an index fund.
                                        </p>

                                        <p>
                                          In the simple terms, ETFs are funds
                                          that track indexes such as CNX Nifty
                                          or BSE Sensex, etc. When you buy
                                          shares/units of an ETF, you are buying
                                          shares/units of a portfolio that
                                          tracks the yield and return of its
                                          native index. The main difference
                                          between ETFs and other types of index
                                          funds is that ETFs don't try to
                                          outperform their corresponding index,
                                          but simply replicate the performance
                                          of the Index. They don't try to beat
                                          the market, they try to be the market.
                                        </p>

                                        <p>
                                          Unlike regular mutual funds, an ETF
                                          trades like a common stock on a stock
                                          exchange. The traded price of an ETF
                                          changes throughout the day like any
                                          other stock, as it is bought and sold
                                          on the stock exchange. The trading
                                          value of an ETF is based on the net
                                          asset value of the underlying stocks
                                          that an ETF represents. ETFs typically
                                          have higher daily liquidity and lower
                                          fees than mutual fund schemes, making
                                          them an attractive alternative for
                                          individual investors.
                                        </p>

                                        <!--<p> <strong>  What are benefits of investing in ETFs </strong> <br/>
                        ETFs combine the range of a diversified portfolio with the simplicity of trading a single stock. Investors can purchase ETF shares on margin, short sell shares, or hold for the long term. ETFs can be bought / sold easily like any other stock on the exchange through terminals across the country.</p>-->

                                        <p>
                                          <strong>Passive Management</strong>
                                          <br />
                                          ETFs are passively managed. The
                                          purpose of an ETF is to match a
                                          particular market index, leading to a
                                          fund management style known as passive
                                          management. Passive management is the
                                          chief distinguishing feature of ETFs,
                                          and it brings a number of advantages
                                          for investors in index funds.
                                          Essentially, passive management means
                                          the fund manager makes only minor,
                                          periodic adjustments to keep the fund
                                          in line with its index. An investor in
                                          an ETF do not want fund managers to
                                          manage their money i.e., decide which
                                          stocks to buy/sell/ hold), but simply
                                          want the returns to mimic those from
                                          the benchmark index. Since buying all
                                          scrips that are part of say, the Nifty
                                          (which has 50 scrips) is not possible,
                                          one could invest in an ETF that tracks
                                          Nifty.
                                        </p>

                                        <p>
                                          This is quite different from an
                                          actively managed fund, like most
                                          mutual funds, where the fund manager
                                          ‘actively’ manages the fund and
                                          continually trades assets in an effort
                                          to outperform the market.
                                        </p>

                                        <p>
                                          Because they are tied to a particular
                                          index, ETFs tend to cover a discrete
                                          number of stocks, as opposed to a
                                          mutual fund whose scope of investment
                                          is subject to continual change. For
                                          these reasons, ETFs mitigate the
                                          element of "managerial risk" that can
                                          make choosing the right fund
                                          difficult. Rather than investing in an
                                          ‘active’ fund managed by a fund
                                          manager, when you buy shares of an ETF
                                          you're harnessing the power of the
                                          market itself.
                                        </p>

                                        <p>
                                          <strong>
                                            ETFs are cost-efficient
                                          </strong>
                                          <br />
                                          Because an ETF tracks an index without
                                          trying to outperform it, it incurs
                                          lower administrative costs than
                                          actively managed portfolios. Typical
                                          ETF administrative costs are lower
                                          than an actively managed fund, coming
                                          in less than 0.20% per annum, as
                                          opposed to the over 1% yearly cost of
                                          some actively managed mutual fund
                                          schemes. Because they have lower
                                          expense ratio, there are fewer
                                          recurring costs to diminish ETF
                                          returns.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      What are the costs of investing in ETFs?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          While the Expense Ratio of ETFs is
                                          lower, there are certain costs that
                                          are unique to ETFs. Since ETFs are
                                          bought traded on stock exchange
                                          through a stock broker, every time an
                                          investor makes a purchase or sale,
                                          he/she pays a brokerage for the
                                          transaction . In addition, an investor
                                          may also incur STT and the usual costs
                                          of trading in stocks, including
                                          differences in the ask-bid spread etc.
                                          Of course, traditional Mutual Fund
                                          investors are also subjected to the
                                          same trading costs indirectly, as the
                                          Fund in turn pays for these costs.
                                        </p>

                                        <p>
                                          <strong>Flexibility of ETFs</strong>
                                          <br />
                                          ETF shares trade exactly like stocks.
                                          Unlike index funds, which are priced
                                          only after market closings, ETFs are
                                          priced and traded continuously
                                          throughout the trading day. They can
                                          be bought on margin, sold short, or
                                          held for the long-term, exactly like
                                          common stock.
                                        </p>

                                        <p>
                                          Yet because their value is based on an
                                          underlying index scrips, ETFs enjoy
                                          the additional benefits of broader
                                          diversification than shares in single
                                          companies, as well as what many
                                          investors perceive as the greater
                                          flexibility that goes with investing
                                          in entire markets, sectors, regions,
                                          or asset types. Because they represent
                                          baskets of stocks, ETFs typically
                                          trade at much higher volumes than
                                          individual stocks. High trading
                                          volumes mean high liquidity, enabling
                                          investors to get into and out of
                                          investment positions with minimum risk
                                          and expense.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Are ETFs only for stocks?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          No. Any asset class that has a
                                          published index and is liquid enough
                                          to be traded daily can be made into an
                                          ETF. Bonds, real estate, commodities,
                                          currencies, and multi-asset funds are
                                          all available in an ETF format. For
                                          instance, Mutual Funds in India offer
                                          Gold ETFs, where the underlying
                                          investment is in physical gold.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      How does the in-kind creation / redemption
                                      mechanism work in ETFs?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          ETFs can either be purchased on the
                                          exchange or directly from the Fund.
                                          The Fund creates / redeems units only
                                          in predefined lot sizes in exchange
                                          for a predefined underlying portfolio
                                          basket (called “creation unit”). Once
                                          the underlying portfolio basket is
                                          deposited with the Fund together with
                                          a cash component, the investor is
                                          allotted the units.
                                        </p>

                                        <p>
                                          This is in-kind creation / redemption
                                          of units, unique to ETFs.
                                          Alternatively, investors can follow
                                          the "Cash Subscription" route in which
                                          they can pay cash directly to the Fund
                                          for purchasing the underlying
                                          portfolio in creation units size.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Why do ETFs trade close to their NAV?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          ETFs have a very transparent portfolio
                                          holding and predefined creation
                                          basket. This allows arbitrageurs to
                                          create and redeem units every day
                                          through the in-kind creation /
                                          redemption mechanism. Such
                                          arbitrageurs are always in the market
                                          to take advantage of any significant
                                          premium or discount between the ETF
                                          market price and its NAV by doing
                                          arbitrage between the ETF and its
                                          underlying portfolio. Thus, the open
                                          architecture of ETFs ensures that
                                          there is no significant premium or
                                          discount to NAV. At the same time,
                                          additional demand / supply is absorbed
                                          due to the action of the arbitrageurs.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      How do ETFs derive their liquidity?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          ETFs derive their liquidity first from
                                          trading of the units in the secondary
                                          market and secondly through the
                                          in-kind creation / redemption process
                                          with the fund in creation unit size.
                                        </p>

                                        <p>
                                          Due to the unique in-kind creation /
                                          redemption process of ETFs, the
                                          liquidity of an ETF is actually the
                                          liquidity of the underlying shares.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-left-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      What is the difference between an ETF and
                                      an Index Fund?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          While both are passively managed, the
                                          biggest difference is that Index Funds
                                          operate in the way all mutual funds
                                          do, in that they are priced at the
                                          close of the trading day based on the
                                          NAV of the underlying securities,
                                          whereas ETFs are priced to the market
                                          throughout the trading day. That means
                                          they are easier to buy and sell
                                          quickly, if need be. Secondly, ETFs
                                          are available only on stock exchanges.
                                          Hence, you need a demat account to
                                          invest in an ETF, whereas for an Index
                                          Fund, you don’t need a demat account
                                          and you may buy or sell the Units of
                                          an Index Fund directly from the mutual
                                          fund in small amounts.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      What happens to the dividends of the
                                      underlying stocks?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Dividends received by an ETF are
                                          typically reinvested in the Fund.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      What happens if constituents in the
                                      underlying index change?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Constituents of an index (i.e., the
                                          underlying stocks) may be changed as
                                          and when securities in the index do
                                          not match specific criteria laid down
                                          by the index service provider or a
                                          better candidate is available to
                                          replace a constituent. The index
                                          service provider usually makes
                                          announcements of change well in
                                          advance. Once securities in the
                                          underlying index are changed, the Fund
                                          can change the securities in its
                                          underlying portfolio by selling the
                                          securities that are being removed from
                                          the index and including those that are
                                          included in the index. This will in no
                                          way affect the units being held by an
                                          investor, as the units will continue
                                          to track the Index, the only effect
                                          may be on the tracking error of the
                                          scheme.
                                        </p>
                                      </div>
                                      <h2
                                        class="resp-accordion hor_1"
                                        role="tab"
                                        aria-controls="hor_1_tab_item-9"
                                        style="
                                          background-color: rgb(125, 222, 220);
                                          border-color: rgb(0, 0, 0);
                                        ">
                                        <span class="resp-arrow"></span>
                                        What is meant by 'Tracking error'?
                                      </h2>
                                      <div
                                        class="resp-tab-content hor_1"
                                        aria-labelledby="hor_1_tab_item-9"
                                        style="border-color: rgb(0, 0, 0)">
                                        <p>
                                          Tracking error is the difference
                                          between an ETF portfolio's returns and
                                          the benchmark or index it was meant to
                                          mimic or beat.
                                        </p>

                                        <p>
                                          ETFs and Index funds, much like other
                                          mutual fund schemes, incur expenses on
                                          cost heads, such as marketing,
                                          advertising, office administration,
                                          brokerage and so on. These expenses
                                          reduce the ETF’s returns. The ETF may
                                          also receive dividend from the
                                          underlying stocks which may
                                          temporarily lead to the ETF
                                          out-performing the benchmark. This
                                          deviation in performance is nothing
                                          but the “tracking error” and is
                                          expressed in percentage terms.
                                          Tracking error is sometimes called
                                          active risk. How well an index fund
                                          manages its inflows and outflows also
                                          determines tracking error. The lower
                                          the tracking error, the better the ETF
                                          / Index fund.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      What is meant by 'Tracking error'?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Tracking error is the difference
                                          between an ETF portfolio's returns and
                                          the benchmark or index it was meant to
                                          mimic or beat.
                                        </p>
                                        <p>
                                          ETFs and Index funds, much like other
                                          mutual fund schemes, incur expenses on
                                          cost heads, such as marketing,
                                          advertising, office administration,
                                          brokerage and so on. These expenses
                                          reduce the ETF’s returns. The ETF may
                                          also receive dividend from the
                                          underlying stocks which may
                                          temporarily lead to the ETF
                                          out-performing the benchmark. This
                                          deviation in performance is nothing
                                          but the “tracking error” and is
                                          expressed in percentage terms.
                                          Tracking error is sometimes called
                                          active risk. How well an index fund
                                          manages its inflows and outflows also
                                          determines tracking error. The lower
                                          the tracking error, the better the ETF
                                          / Index fund.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      What are the benefits of investing in
                                      ETFs?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          <!--<strong>  What are benefits of investing in ETFs </strong> <br/>-->
                                          ETFs combine the range of a
                                          diversified portfolio with the
                                          simplicity of trading a single stock.
                                          Investors can purchase ETF shares on
                                          margin, short sell shares, or hold for
                                          the long term. ETFs can be bought /
                                          sold easily like any other stock on
                                          the exchange through terminals across
                                          the country.
                                        </p>
                                        <p>
                                          <strong>Asset Allocation:</strong>
                                          Managing asset allocation can be
                                          difficult for individual investors
                                          given the costs and assets required to
                                          achieve proper levels of
                                          diversification. ETFs provide
                                          investors with exposure to broad
                                          segments of the equity markets. They
                                          cover a range of style and size
                                          spectrums, enabling investors to build
                                          customized investment portfolios
                                          consistent with their financial needs,
                                          risk tolerance, and investment
                                          horizon. Both institutional and
                                          individual investors use ETFs to
                                          conveniently, efficiently, and cost
                                          effectively allocate their assets.
                                        </p>

                                        <p>
                                          <strong>Cash Equitisation:</strong>
                                          <br />
                                          Investors typically seek exposure to
                                          equity markets, but often need time to
                                          make investment decisions. ETFs
                                          provide a "Parking Place" for cash
                                          that is designated for equity
                                          investment. Because ETFs are liquid,
                                          investors can participate in the
                                          market while deciding where to invest
                                          the funds for the longer-term, thus
                                          avoiding potential opportunity costs.
                                          Historically, investors have relied
                                          heavily on derivatives to achieve
                                          temporary exposure. However,
                                          derivatives are not always a practical
                                          solution. The large denomination of
                                          most derivative contracts can preclude
                                          investors, both institutional and
                                          individual, from using them to gain
                                          market exposure. In this case and in
                                          those where derivative use may be
                                          restricted, ETFs are a practical
                                          alternative.
                                        </p>

                                        <p>
                                          <strong>Hedging Risks:</strong>
                                          <br />
                                          ETFs are an excellent hedging vehicle
                                          because they can be borrowed and sold
                                          short. The smaller denominations in
                                          which ETFs trade relative to most
                                          derivative contracts provides a more
                                          accurate risk exposure match,
                                          particularly for small investment
                                          portfolios.
                                        </p>
                                        <p>
                                          <strong>
                                            Arbitrage (cash vs futures) and
                                            covered option strategies:
                                          </strong>
                                          <br />
                                          ETFs can be used to arbitrage between
                                          the cash and futures market, as they
                                          are very easy to trade. ETFs can also
                                          be used for cover option strategies on
                                          the index.
                                        </p>
                                        <p><strong></strong></p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="mutual-7"
              class="wp-block-group mutual-fund-content tab-pane fade">
              <div class="wp-block-group__inner-container">
                <div
                  class="Optimum-official-offerings"
                  id="Optimum-wealth-home">
                  <div
                    class="home-wealth-faq typeofmfsection wealth-faq-wrapper"
                    id="Myth1">
                    <div class="container">
                      <div class="row">
                        <div class="col-12 nopadding">
                          <div class="accordion_container">
                            <div
                              class="col-sm-12 col-md-12 col-xs-12 nopadding">
                              <div class="row">
                                <div
                                  class="col-md-12 col-xs-12 col-sm-12 mbnopadding">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Gold ETF
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          A
                                          <strong>Gold ETF</strong>
                                          is an exchange-traded fund
                                          <strong>(ETF)</strong>
                                          that aims to track the domestic
                                          physical
                                          <strong>gold</strong>
                                          price. They are passive investment
                                          instruments that are based on gold
                                          prices and invest in gold bullion.
                                        </p>
                                        <p>
                                          <strong>In short, Gold ETFs</strong>
                                          are units representing physical
                                          <strong>gold</strong>
                                          which may be in paper or
                                          dematerialised form. One
                                          <strong>Gold ETF</strong>
                                          unit is equal to 1 gram of
                                          <strong>gold</strong>
                                          and is backed by physical
                                          <strong>gold</strong>
                                          of very high purity. Gold ETFs combine
                                          the flexibility of stock investment
                                          and the simplicity of gold
                                          investments.
                                        </p>
                                        <p>
                                          Gold ETFs are listed and traded on the
                                          National Stock Exchange of India (NSE)
                                          and Bombay Stock Exchange Ltd. (BSE)
                                          like a stock of any company. Gold ETFs
                                          trade on the cash segment of BSE &amp;
                                          NSE, like any other company stock, and
                                          can be bought and sold continuously at
                                          market prices.
                                        </p>
                                        <p>
                                          Buying Gold ETFs means you are
                                          purchasing gold in an electronic form.
                                          You can buy and sell gold ETFs just as
                                          you would trade in stocks. When you
                                          actually redeem Gold ETF, you don’t
                                          get physical gold, but receive the
                                          cash equivalent. Trading of gold ETFs
                                          takes place through a dematerialised
                                          account (Demat) and a broker, which
                                          makes it an extremely convenient way
                                          of electronically investing in gold.
                                        </p>
                                        <p>
                                          Because of its direct gold pricing,
                                          there is a complete transparency on
                                          the holdings of a Gold ETF. Further
                                          due to its unique structure and
                                          creation mechanism, the ETFs have much
                                          lower expenses as compared to physical
                                          gold investments.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-left-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      How does a Gold ETF work?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <ul>
                                          <li>
                                            <strong>Purity &amp; Price:</strong>
                                            <br />
                                            Gold ETFs are represented by 99.5%
                                            pure physical gold bars. Gold ETF
                                            prices are listed on the website of
                                            BSE/NSE and can be bought or sold
                                            anytime through a stock broker.
                                            Unlike gold jewellery, gold ETF can
                                            be bought and sold at the same price
                                            Pan-India.&nbsp;
                                          </li>
                                          <li>
                                            <strong>Where to buy:</strong>
                                            <br />
                                            Gold ETFs can be bought on BSE/NSE
                                            through the broker using a demat
                                            account and trading account. A
                                            brokerage fee and minor fund
                                            management charges are applicable
                                            when buying or selling gold ETFs
                                          </li>
                                        </ul>
                                        <h2
                                          class="sub-head-new sub-heading main-block animated fadeInDown">
                                          Risks:
                                        </h2>
                                        <p>
                                          Gold ETFs are subject to market risks
                                          impacting the price of gold. Gold ETFs
                                          are subject to SEBI Mutual Funds
                                          Regulations. Regular audit of the
                                          physical gold bought by fund houses by
                                          a statutory auditor is mandatory.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-left-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Who should invest in Gold ETF?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Gold ETFs are ideal for investors who
                                          wish to invest in gold but do not want
                                          to invest in physical gold due to the
                                          storage hassles / doubt about purity
                                          of gold and are also looking to get
                                          tax benefits. There is no premium or
                                          making charge, so investors stand to
                                          save money if their investment is
                                          substantial. What’s more, one can
                                          purchase as low as one unit (which is
                                          1 gram).
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-left-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Advantages of buying Gold ETF Units?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <ul>
                                          <li>
                                            Purity of the gold is guaranteed and
                                            each unit is backed by physical gold
                                            of high purity.
                                          </li>
                                          <li>
                                            Transparent and real time gold
                                            prices.
                                          </li>
                                          <li>
                                            Listed and traded on stock exchange.
                                          </li>
                                          <li>
                                            A tax efficient way to hold gold as
                                            the income earned from them is
                                            treated as long term capital gain.
                                          </li>
                                          <li>
                                            No wealth tax, no security
                                            transaction tax, no VAT and no sales
                                            tax.
                                          </li>
                                          <li>
                                            No fear of theft - Safe and secure
                                            as units held in Demat. One also
                                            saves on safe deposit locker
                                            charges.
                                          </li>
                                          <li>
                                            ETFs are accepted as collateral for
                                            loans.
                                          </li>
                                          <li>No entry and exit load.</li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-md-6 col-xs-6 col-sm-6 mbnopadding padding-left-zero">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      How to sell / redeem Gold ETF?
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          Gold ETFs can be sold at the stock
                                          exchange through the broker using a
                                          demat account and trading account.
                                          Since one is investing in an ETF that
                                          is backed by physical gold, ETFs are
                                          best used as a tool to benefit from
                                          the price of gold rather than to get
                                          access to physical gold. So, when one
                                          liquidates Gold ETF Units, one is paid
                                          as per domestic market price of the
                                          gold. AMCs also permit redemption of
                                          Gold ETF Units in the form of physical
                                          gold in ‘Creation Unit’ size, if one
                                          holds equivalent of 1kg of gold in
                                          ETFs, or in multiples thereof.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="mutual-8"
              class="wp-block-group mutual-fund-content tab-pane fade">
              <div class="wp-block-group__inner-container">
                <div
                  class="Optimum-official-offerings"
                  id="Optimum-wealth-home">
                  <div
                    class="home-wealth-faq typeofmfsection wealth-faq-wrapper"
                    id="Myth1">
                    <div class="container">
                      <div class="row">
                        <div class="col-12 nopadding">
                          <div class="accordion_container">
                            <div
                              class="col-sm-12 col-md-12 col-xs-12 nopadding">
                              <div class="row">
                                <div
                                  class="col-md-12 col-xs-12 col-sm-12 mbnopadding">
                                  <div
                                    class="col-sm-12 col-md-12 col-xs-12 nopadding">
                                    <div class="accordion_head">
                                      Fund Of Funds (FOF)
                                      <span class="plusminus">+</span>
                                    </div>
                                    <div
                                      class="accordion_body"
                                      style="display: none">
                                      <div class="item-text">
                                        <p>
                                          A ‘Fund Of Funds’ (FOF) is an
                                          investment strategy of holding a
                                          portfolio of other investment
                                          <strong>funds</strong>
                                          rather than investing directly in
                                          stocks, bonds or other securities. An
                                          FOF Scheme of a primarily invests in
                                          the units of another Mutual Fund
                                          scheme. This type of investing is
                                          often referred to as multi-manager
                                          investment
                                        </p>
                                        <p>
                                          These schemes offer the investor an
                                          opportunity to diversify risk by
                                          spreading investments across multiple
                                          funds. The underlying investments for
                                          a FoF are the units of other mutual
                                          fund schemes either from the same
                                          mutual fund or other mutual fund
                                          houses.
                                        </p>
                                        <p>
                                          Experts believe fund of funds are
                                          generally better suited for smaller
                                          investors that want to gain access to
                                          a range of different asset classes or
                                          for those whose advisers do not have
                                          the expertise to make single manager
                                          recommendations.
                                        </p>
                                        <p>
                                          Under current Income Tax regime in
                                          India, a FOF is treated as a
                                          non-Equity fund and consequently taxed
                                          accordingly. In other words, even
                                          though a FOF may be investing in
                                          equity oriented funds, the FOF itself
                                          is not regarded as an equity oriented
                                          fund, and consequently, the tax
                                          benefits currently available to an
                                          equity fund are not available to an
                                          FOF. Consequently, in case of FOFs
                                          investing in equity securities of
                                          domestic companies via EOFs, there is
                                          dual levy of Dividend Distribution Tax
                                          (DDT), viz., when the domestic
                                          companies distribute dividends to
                                          their shareholders and again, when the
                                          FOF distributes the dividends to its
                                          unit-holders.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="grid-layout-common">
    <div class="container">
      <div class="col-md-12 col-xs-12 col-sm-12 nopadding">
        <div class="product-card-grid hover-animation" data-grid-size="8">
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Types_Of_MF"
            target="_self">
            <span>
              Mutual Funds -
              <br />
              <span class="no-wrap-text">Introduction & More</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card active"
            href="mf/Types_Of_MF"
            target="_self">
            <span>
              Various types
              <br />
              <span class="no-wrap-text">of Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/SIP"
            target="_self">
            <span>
              Systematic
              <br />
              <span class="no-wrap-text">Investment Plan?</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Advantages_Of_MutualFundsComponent"
            target="_self">
            <span>
              Advantages of
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/categorization-of-mutual-funds"
            target="_self">
            <span>
              Categorisation of
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/risks-in-mutual-funds"
            target="_self">
            <span>
              Risk Factors in
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/FAQ#Myth"
            target="_self">
            <span>
              Myths & Facts
              <br />
              <span class="no-wrap-text">about Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/FAQ#FAQ"
            target="_self">
            <span>
              What is NAV?
              <br />
              <span class="no-wrap-text">& Other FAQs</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-ebe318f3-49dd-4b4f-9c3a-0cb8514a69fd"
            class="card link-plain featured customCard"
            (click)="modalPopOpen()"
            target="_self">
            <p
              style="
                font-size: 19px;
                color: #000;
                font-weight: bold;
                margin-bottom: 0px;
              ">
              Schedule a Call back
            </p>
          </a>
        </div>
      </div>
    </div>
  </section>
</main>

<IFA-footer></IFA-footer>
